(() => {
  function init(marker) {
    const section = marker.closest('.main-product__info-container');
    if (!section || section.dataset.moriiPurchaseReady === 'true') return;
    const breaks = section.querySelector('quantity-breaks');
    const form = section.querySelector('.main-product-form');
    const stock = section.querySelector('[data-morii-stock-status]');
    if (!breaks || !form || !stock) return;
    section.dataset.moriiPurchaseReady = 'true';
    const variantData = section.querySelector('[data-morii-stock-variants]');
    let inventory = [];
    try { inventory = JSON.parse(variantData.textContent); } catch (_) { /* Keep server-rendered status. */ }
    const variantJson = section.querySelector('quantity-breaks script[data-has-variants]');
    let variants = [];
    try { variants = JSON.parse(variantJson.textContent); } catch (_) { /* Thumbnails are optional. */ }
    const selectedId = () => Number(form.querySelector('input[name="id"]')?.value);
    const refreshStock = () => {
      const checked = breaks.querySelector('input[name="quantity"]:checked');
      const card = checked && breaks.querySelector(`label[for="${checked.id}"]`);
      const rows = Number(checked?.value || 1) > 1 ? [...(card?.querySelectorAll('.quantity-break__selector-item') || [])] : [];
      const chosenIds = rows.length ? rows.map(row => {
        const values = [...row.querySelectorAll('select')].map(select => select.value);
        return variants.find(variant => values.every((value, index) => variant[`option${index + 1}`] === value))?.id;
      }) : [selectedId()];
      if (chosenIds.some(id => !id)) return;
      const counts = new Map();
      chosenIds.forEach(id => counts.set(Number(id), (counts.get(Number(id)) || 0) + 1));
      const chosen = [...counts].map(([id, count]) => ({ variant: inventory.find(item => Number(item.id) === id), count }));
      if (chosen.some(item => !item.variant)) return;
      const unavailable = chosen.some(({ variant }) => !variant.available);
      const inStock = !unavailable && chosen.every(({ variant, count }) => variant.tracked && variant.inventory >= count);
      const label = unavailable ? 'Out of Stock' : inStock ? 'In Stock' : 'Available to Order';
      stock.querySelector('.morii-stock-status__text').textContent = label;
      stock.querySelector('.morii-stock-status__dot').classList.toggle('morii-stock-status__dot--muted', !inStock);
      stock.querySelector('.morii-stock-status__divider').hidden = unavailable;
      stock.querySelector('.morii-stock-status__shipping-group').hidden = unavailable;
      stock.querySelector('.morii-stock-status__shipping').textContent = inStock ? 'Ready to Ship Worldwide' : 'Worldwide Shipping';
    };
    const refreshSinglePrice = () => {
      const variant = variants.find(item => Number(item.id) === selectedId());
      const save = breaks.querySelector('[data-morii-single-save]');
      const compare = breaks.querySelector('[data-morii-single-compare]');
      if (!variant || !save || !compare) return;
      const price = Number(variant.price);
      const original = Number(variant.compare_at_price);
      const discounted = Number.isFinite(original) && original > price && original <= price * 3;
      save.hidden = !discounted;
      compare.hidden = !discounted;
      if (!discounted) return;
      const currency = breaks.dataset.moriiCurrency || 'USD';
      const locale = document.documentElement.lang || 'en-US';
      const format = cents => new Intl.NumberFormat(locale, {
        style: 'currency',
        currency,
        minimumFractionDigits: cents % 100 === 0 ? 0 : 2,
        maximumFractionDigits: 2
      }).format(cents / 100);
      save.textContent = `SAVE ${format(original - price)}`;
      compare.textContent = format(original);
    };
    const refreshOffer = () => {
      const checked = breaks.querySelector('input[name="quantity"]:checked');
      form.classList.toggle('morii-bundle-selected', Number(checked?.value || 1) > 1);
    };
    const refreshThumbs = () => {
      breaks.querySelectorAll('.quantity-break__selector-item').forEach(row => {
        const values = [...row.querySelectorAll('select')].map(select => select.value);
        const match = variants.find(variant => values.every((value, index) => variant[`option${index + 1}`] === value));
        const src = match?.featured_image?.src;
        let thumb = row.querySelector('.morii-bundle-thumb');
        if (!src) { if (thumb) thumb.remove(); return; }
        if (!thumb) {
          thumb = document.createElement('img');
          thumb.className = 'morii-bundle-thumb';
          thumb.alt = '';
          thumb.loading = 'lazy';
          row.prepend(thumb);
        }
        thumb.src = src.startsWith('//') ? `https:${src}` : src;
      });
    };
    const refresh = () => { refreshOffer(); refreshStock(); refreshThumbs(); refreshSinglePrice(); };
    section.addEventListener('change', () => {
      requestAnimationFrame(() => requestAnimationFrame(refresh));
      window.setTimeout(() => { refreshStock(); refreshSinglePrice(); }, 300);
    });
    section.addEventListener('variant:change', refresh);
    form.querySelector('input[name="id"]')?.addEventListener('change', refresh);
    refresh();
  }
  function initRealLife() {
    document.querySelectorAll('[data-morii-real-life]').forEach(region => {
      if (region.dataset.moriiRealLifeReady === 'true') return;
      const slides = [...region.querySelectorAll('.morii-real-life__slide')];
      if (!slides.length) return;
      const carousel = region.querySelector('.morii-real-life__carousel');
      const pagination = document.createElement('div');
      pagination.className = 'morii-real-life__pagination';
      pagination.setAttribute('aria-hidden', 'true');
      const dots = slides.map(() => {
        const dot = document.createElement('span');
        dot.className = 'morii-real-life__dot';
        pagination.append(dot);
        return dot;
      });
      if (slides.length > 1) carousel?.insertAdjacentElement('afterend', pagination);
      let current = 0;
      const show = (index, direction) => {
        current = (index + slides.length) % slides.length;
        region.style.setProperty('--morii-slide-enter', direction < 0 ? '-1.2rem' : '1.2rem');
        region.classList.add('morii-real-life--transitioning');
        slides.forEach((slide, slideIndex) => { slide.hidden = slideIndex !== current; });
        dots.forEach((dot, dotIndex) => { dot.classList.toggle('is-active', dotIndex === current); });
      };
      dots[0].classList.add('is-active');
      region.querySelector('[data-morii-real-life-prev]')?.addEventListener('click', () => show(current - 1, -1));
      region.querySelector('[data-morii-real-life-next]')?.addEventListener('click', () => show(current + 1, 1));
      if (carousel && slides.length > 1) {
        let start = null;
        let suppressClick = false;
        carousel.addEventListener('pointerdown', event => {
          if (event.pointerType === 'mouse' && event.button !== 0) return;
          start = { id: event.pointerId, x: event.clientX, y: event.clientY };
        });
        carousel.addEventListener('pointerup', event => {
          if (!start || start.id !== event.pointerId) return;
          const deltaX = event.clientX - start.x;
          const deltaY = event.clientY - start.y;
          start = null;
          if (Math.abs(deltaX) < 42 || Math.abs(deltaX) < Math.abs(deltaY) * 1.2) return;
          suppressClick = true;
          const direction = deltaX < 0 ? 1 : -1;
          show(current + direction, direction);
          window.setTimeout(() => { suppressClick = false; }, 400);
        });
        carousel.addEventListener('pointercancel', () => { start = null; });
        carousel.addEventListener('click', event => {
          if (!suppressClick) return;
          event.preventDefault();
          event.stopImmediatePropagation();
          suppressClick = false;
        }, true);
      }
      region.querySelectorAll('[data-morii-real-life-open]').forEach(button => {
        button.addEventListener('click', () => {
          const dialog = region.querySelector(`[data-morii-real-life-dialog="${button.dataset.moriiRealLifeOpen}"]`);
          if (!dialog) return;
          if (!dialog.open) dialog.showModal();
          const playback = dialog.querySelector('video')?.play();
          if (playback && typeof playback.catch === 'function') playback.catch(() => {});
        });
      });
      region.querySelectorAll('.morii-real-life__dialog').forEach(dialog => {
        dialog.querySelector('.morii-real-life__close')?.addEventListener('click', () => dialog.close());
        dialog.addEventListener('click', event => { if (event.target === dialog) dialog.close(); });
        dialog.addEventListener('close', () => dialog.querySelector('video')?.pause());
      });
      region.dataset.moriiRealLifeReady = 'true';
    });
  }
  function initAdaptiveGallery() {
    document.querySelectorAll('media-gallery').forEach(gallery => {
      if (gallery.dataset.moriiAdaptiveGalleryReady === 'true') return;
      const slider = gallery.querySelector('.product__media-list.slider--mobile');
      const slides = slider && [...slider.querySelectorAll(':scope > .product__media-item')];
      if (!slider || slides.length < 2) return;
      const mobile = window.matchMedia('(max-width: 749px)');
      let pending = false;
      const update = () => {
        pending = false;
        if (!mobile.matches) {
          slider.style.removeProperty('height');
          return;
        }
        const firstLeft = slides[0].offsetLeft;
        let selected = slides[0];
        let smallestGap = Infinity;
        slides.forEach(slide => {
          const gap = Math.abs(slide.offsetLeft - firstLeft - slider.scrollLeft);
          if (gap < smallestGap) {
            selected = slide;
            smallestGap = gap;
          }
        });
        const height = Math.ceil(selected.getBoundingClientRect().height);
        if (height > 0) slider.style.height = `${height}px`;
      };
      const schedule = () => {
        if (pending) return;
        pending = true;
        requestAnimationFrame(update);
      };
      slider.dataset.moriiAdaptiveGallery = 'true';
      slider.addEventListener('scroll', schedule, { passive: true });
      window.addEventListener('resize', schedule, { passive: true });
      mobile.addEventListener?.('change', schedule);
      if ('ResizeObserver' in window) {
        const observer = new ResizeObserver(schedule);
        slides.forEach(slide => observer.observe(slide));
      }
      gallery.dataset.moriiAdaptiveGalleryReady = 'true';
      schedule();
    });
  }
  function initAll() { initAdaptiveGallery(); document.querySelectorAll('[data-morii-purchase-refresh]').forEach(init); initRealLife(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initAll, { once: true });
  else initAll();
  document.addEventListener('shopify:section:load', initAll);
})();
